(function (scope) {
  'use strict';

  var Gallery = function (elementsOrSelector) {
    Gallery.STATE_OPEN = 'state_open';
    Gallery.STATE_CLOSED = 'state_closed';

    this.buttonSelector = '.js-gallery-expand';
    this._state = Gallery.STATE_CLOSED;
    this._expandHeight = 0;

    if (typeof elementsOrSelector === 'string') {
      this.$elements = $(elementsOrSelector);
    } else if (elementsOrSelector !== undefined) {
      this.$elements = elementsOrSelector;
    }

    if (this.$elements.length) {
      this.initialize();
    } else {
      console.warn('Gallery selector doesn\'t match any elements.');
    }
  };

  Gallery.prototype.initialize = function () {
    this.$openButton = $(this.buttonSelector);

    this._calcExpandHeight();
    if (this._expandHeight > 0) {
      if (this.$openButton.length) {
        this._handleClick = this._onClick.bind(this);
        this.$openButton.on('click touchdown', this._handleClick);
      }

      this._hasOverflowItems = true;

      this._bindClacExpandHeight = this._calcExpandHeight.bind(this);
      this._handleResize = this._onResize.bind(this);
      window.addEventListener('resize', this._handleResize);
    } else {
      this._state = Gallery.STATE_OPEN;
      this.$openButton.remove();
    }

    this._handleStateUpdate();
  };

  Gallery.prototype._onResize = function (event) {
    if (this._throttle) {
      window.clearTimeout(this._throttle);
      this._throttle = null;
    }
    this._throttle = window.setTimeout(this._bindClacExpandHeight, 500);
  };

  Gallery.prototype._calcExpandHeight = function () {
    var rows = this.$elements.find('> .grid-row');
    if (rows.length > 1) {
      this._whenSafeToMeasure(function(scope) {
        var firstRow = rows.first()[0].getBoundingClientRect();
        scope.$elements.css('min-height', firstRow.height + 'px');
        scope._expandHeight = Math.ceil(firstRow.height * rows.length);
      });
    }
  };

  Gallery.prototype._whenSafeToMeasure = function (handleMeasurements) {
    this.$elements.removeClass('is-animated');
    if (handleMeasurements) {
      handleMeasurements(this);
    }
    this.$elements.addClass('is-animated');
  };

  Gallery.prototype._onClick = function (event) {
    this._state = this._state === Gallery.STATE_CLOSED ? Gallery.STATE_OPEN : Gallery.STATE_CLOSED;
    this._handleStateUpdate();
  };

  Gallery.prototype._handleStateUpdate = function () {
    this.$elements.toggleClass('is-open', this._state === Gallery.STATE_OPEN);
    this.$elements.css('height', this._state === Gallery.STATE_CLOSED ?
      0 : this._hasOverflowItems ?
        this._expandHeight : 'auto'
    );
  };

  scope.Gallery = Gallery;
})(window.Roots || (window.Roots = {}));
